<div [formGroup]="treatmentFormGroup">
  <div *ngIf="existingTreatmentFormData.directSeedToPots === false" [formGroup]="flatInstructions">
    <h5>Flat Instructions</h5>
    <div *ngIf="flatInstructionsSubstrate" class="form-group" [class.has-error]="flatInstructionsSubstrate.invalid">
      <label class="control-label col-sm-3">Substrate: {{existingTreatmentFormData.flatSubstrate}}</label>
      <div class="col-sm-9">
        <textarea class="form-control" maxlength="500" rows="2" formControlName="substrate"></textarea>
      </div>
    </div>
    <div *ngIf="flatInstructionsIrrigation" class="form-group" [class.has-error]="flatInstructionsIrrigation.invalid">
      <label class="control-label col-sm-3 ">Irrigation: {{existingTreatmentFormData.flatIrrigationMethod}}</label>
      <div class="col-sm-9">
        <textarea class="form-control" maxlength="500" rows="2" formControlName="irrigation"></textarea>
      </div>
    </div>
    <div *ngIf="flatInstructionsFertigation" class="form-group" [class.has-error]="flatInstructionsFertigation.invalid">
      <label class="control-label col-sm-3 ">Fertigation: {{existingTreatmentFormData.flatFertigationMethod}}</label>
      <div class="col-sm-9">
        <textarea class="form-control" maxlength="500" rows="2" formControlName="fertigation"></textarea>
      </div>
    </div>
    <app-facility-selector
      *ngIf="flatLocation"
      [facilitySelectionGroup]="flatLocation"
      [facilityTypes]="facilityTypes"
      [facilities]="facilityNames"
      label="Flat Location">
    </app-facility-selector>
  </div>

  <div [formGroup]="pottingInstructions">
    <hr>
    <h5>Potting Instructions</h5>
    <div *ngIf="pottingInstructionsSubstrate" class="form-group" [class.has-error]="pottingInstructionsSubstrate.invalid">
      <label class="control-label col-sm-3">Substrate: {{existingTreatmentFormData.potSubstrate}}</label>
      <div class="col-sm-9">
          <textarea class="form-control" maxlength="500" rows="2" formControlName="substrate"></textarea>
      </div>
    </div>
    <div *ngIf="pottingInstructionsIrrigation" class="form-group" [class.has-error]="pottingInstructionsIrrigation.invalid">
      <label class="control-label col-sm-3">Irrigation: {{existingTreatmentFormData.potIrrigationMethod}}</label>
      <div class="col-sm-9">
          <textarea class="form-control" maxlength="500" rows="2" formControlName="irrigation"></textarea>
      </div>
    </div>
    <div *ngIf="pottingInstructionsFertigation" class="form-group" [class.has-error]="pottingInstructionsFertigation.invalid">
      <label class="control-label col-sm-3">Fertigation: {{existingTreatmentFormData.potFertigationMethod}}</label>
      <div class="col-sm-9">
          <textarea class="form-control" maxlength="500" rows="2" formControlName="fertigation"></textarea>
      </div>
    </div>

    <app-facility-selector
      [facilitySelectionGroup]="automationPotLocation"
      [facilityTypes]="facilityTypes"
      [facilities]="facilityNames"
      label="Pot Location - Automated">
    </app-facility-selector>

    <app-facility-selector
      [facilitySelectionGroup]="staticPotLocation"
      [facilityTypes]="facilityTypes"
      [facilities]="facilityNames"
      label="Pot Location - Static">
    </app-facility-selector>
  </div>

  <div *ngIf="showPlantHandlingInstructions()" [formGroup]="plantHandlingInstructions">
    <hr>
    <h5>Plant Handling Instructions</h5>
    <div *ngIf="plantHandlingLighting" class="form-group" [class.has-error]="plantHandlingLighting.invalid">
      <label class="control-label col-sm-3">Lighting: {{existingTreatmentFormData.plantHandlingLightingInstruction}}</label>
      <div class="col-sm-9">
          <textarea class="form-control" maxlength="500" rows="2" formControlName="lighting"></textarea>
      </div>
    </div>
    <div *ngIf="plantHandlingTemperature" class="form-group" [class.has-error]="plantHandlingTemperature.invalid">
      <label class="control-label col-sm-3">Temperature: {{existingTreatmentFormData.plantHandlingTemperatureInstruction}}</label>
      <div class="col-sm-9">
          <textarea class="form-control" maxlength="500" rows="2" formControlName="temperature"></textarea>
      </div>
    </div>
    <div *ngIf="plantHandlingHumidity" class="form-group" [class.has-error]="plantHandlingHumidity.invalid">
      <label class="control-label col-sm-3">Humidity: {{existingTreatmentFormData.plantHandlingHumidityInstruction}}</label>
      <div class="col-sm-9">
          <textarea class="form-control" maxlength="500" rows="2" formControlName="humidity"></textarea>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-planning-modal/request-planning-treatment/request-planning-treatment.component.html